import { createContext } from 'react';

export const InjectableDependencyOverrides = createContext({});
